export const colors = {
  'basecamp': '#ffcc00',
  'activate': '#015851',
  'accelerate': '#46c3b2',
  'advance': '#0083eb',
  'achieve': '#1d4588',
}

export const phases = Object.keys(colors)
